/**
 * Markdown Preview Command
 * Preview markdown files in terminal
 */
import { Command } from 'commander';
import { readFile } from 'fs/promises';
import { marked } from 'marked';
import TerminalRenderer from 'marked-terminal';

async function handleMarkdownPreview(
    file: string,
    options: {
        raw: boolean;
    }
): Promise<void> {
    try {
        let content = await readFile(file, 'utf-8');

        if (options.raw) {
            // Show raw markdown with basic formatting
            console.log('📄 Markdown File (Raw):');
            console.log('────────────────────────────────────────\n');
            console.log(content);
            console.log();
        } else {
            // Pre-process content to replace Mermaid blocks with placeholders
            content = content.replace(/```mermaid\n([\s\S]*?)```/g, (match, code) => {
                return `\n🎨 **Mermaid Diagram**\n\n\`\`\`\n${code.trim()}\n\`\`\`\n\n💡 *Tip: Mermaid diagrams cannot be rendered in terminal. View in a Markdown viewer.*\n`;
            });

            // Render markdown in terminal
            marked.setOptions({
                // @ts-ignore - marked-terminal types may not match perfectly
                renderer: new TerminalRenderer(),
            });

            const rendered = marked(content);

            console.log('📄 Markdown Preview:');
            console.log('────────────────────────────────────────\n');
            console.log(rendered);
        }
    } catch (error) {
        console.error('❌ Error:', error instanceof Error ? error.message : String(error));
        process.exit(1);
    }
}

export function createMarkdownPreviewCommand(): Command {
    const cmd = new Command('markdown-preview')
        .description('Preview markdown file in terminal')
        .argument('<file>', 'Markdown file path')
        .option('--raw', 'Show raw markdown instead of rendered')
        .addHelpText('after', `
Examples:
  $ jai1 utils markdown-preview README.md
  $ jai1 utils markdown-preview ./docs/guide.md
  $ jai1 utils markdown-preview CHANGELOG.md --raw
  $ jai1 utils markdown-preview ./notes.md
`)
        .showHelpAfterError('(add --help for additional examples)')
        .action(async (file, options) => {
            await handleMarkdownPreview(file, options);
        });

    return cmd;
}
